<ngx-loading-bar [color]="'#ffde00'"></ngx-loading-bar>
<ngx-spinner></ngx-spinner>
<router-outlet></router-outlet>
